import { enableProdMode } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import { loadRuntimeConfig, setRuntimeConfig } from "./runtime-config";

/*
 * Configuration is fetched BEFORE bootstrapping.
 *
 * MSAL's PublicClientApplication is built by a provider factory during module
 * instantiation, so its client id must already be available — an
 * APP_INITIALIZER would run too late. See src/runtime-config.ts.
 *
 * AppModule is imported DYNAMICALLY, and that is load-bearing: `StoreDevtoolsModule
 * .instrument({ logOnly: runtimeConfig().production })` sits in an @NgModule imports
 * array, which JavaScript evaluates when the module is first imported. A static
 * `import { AppModule }` is hoisted above this code, so the configuration would be
 * read before it had been set. Importing here guarantees the ordering.
 */
loadRuntimeConfig()
  .then(async (config) => {
    setRuntimeConfig(config);

    if (config.production) {
      enableProdMode();
    }

    const { AppModule } = await import("./app/app.module");
    return platformBrowser().bootstrapModule(AppModule);
  })
  .catch((err) => console.error(err));
